import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login-register',
  templateUrl: './login-register.component.html',
  styleUrls: ['./login-register.component.css']
})
export class LoginRegisterComponent implements OnInit {

  selectedIndex: number = 0

  activeLink: string

  seoData: SeoSocialShareData = {
    title:  'Neprose - Login | Signup',
    description: 'Login to Neprose to use our services and enjoy our features. New to Neprose? Register to Neprose to use our services and enjoy our features.',
    image: environment.url+'/assets/logo.png'
  };

  constructor( private router: Router, private seo: SeoSocialShareService ) { }

  ngOnInit(): void {
    this.seo.setData(this.seoData)
    this.activeLink = this.router.url
    if(this.activeLink == '/login'){
      this.selectedIndex = 0
    }else if(this.activeLink == '/register'){
      this.selectedIndex = 1
    }
  }

  changeRoute(){
    if(this.selectedIndex == 0){
      this.router.navigate(['/login'])
    }else if(this.selectedIndex == 1){
      this.router.navigate(['/register'])
    }
  }

}